import { c as _c } from "react/compiler-runtime";
import { CardActionMenu } from "@components/progress-overview/card-action-menu";
import { Text } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { withEllipsis } from "@styles/common-styles";
/** Renders the main layout of a menu card */
export function CardLayout(t0) {
  const $ = _c(22);
  const {
    name,
    projectName,
    menu,
    icon,
    titleWrapperSx,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      p: 0.5,
      mx: 4
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== titleWrapperSx) {
    t2 = {
      ...titleWrapperSx,
      justifyContent: "space-between",
      alignItems: "center",
      gap: 0.375
    };
    $[1] = titleWrapperSx;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      ...withEllipsis,
      color: "text.primary",
      flex: "1"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== name) {
    t4 = <Text variant="bodyM" sx={t3}><var>{name}</var></Text>;
    $[4] = name;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== menu) {
    t5 = menu && <CardActionMenu menu={menu} />;
    $[6] = menu;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== icon || $[9] !== t2 || $[10] !== t4 || $[11] !== t5) {
    t6 = <Stack direction="row" sx={t2}>{icon}{t4}{t5}</Stack>;
    $[8] = icon;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== projectName) {
    t7 = projectName && <Text variant="bodyS" sx={{
      pb: 1.25,
      ...withEllipsis,
      color: "text.secondary"
    }}><var>{projectName}</var></Text>;
    $[13] = projectName;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      pb: 1.5,
      gap: 1
    };
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== children) {
    t9 = <Stack component="div" sx={t8}>{children}</Stack>;
    $[16] = children;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t6 || $[19] !== t7 || $[20] !== t9) {
    t10 = <Stack sx={t1}>{t6}{t7}{t9}</Stack>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}